import { AxiosPromise } from 'axios';
import { ServicioProxy } from '../../../config/enums';
import { AxiosVue } from '../../../AxiosVue';

type DashboardResponse<T = any> = {
  MENSAJE_RESPUESTA?: string;
  CODIGO_RESPUESTA?: string;
  LISTA?: T;
};

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = (
  body: any,
  path: string
): AxiosPromise<DashboardResponse> =>
  axios.http.post<DashboardResponse>(`Metabase/PostgenericA/` + path, body);

export const fetchConsultaInstalaciones = (
  body: any,
  path: string
): AxiosPromise<DashboardResponse> => makeHttpRequest(body, path);
